.content {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 24px 56px;
  width: 592px;
}

.close {
  align-self: flex-end;
  margin-bottom: 16px;
}

.title {
  margin-top: 16px;
}

.panel {
  align-items: center;
  background-color: var(--colors-grays-ultralight);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  max-width: 600px;
  padding: 16px;
  text-align: center;
}

.action {
  margin-top: 24px;
}

.mobile {
  padding: 0 24px 24px;
  width: auto;

  .close {
    margin-bottom: 8px;
    margin-right: -12px;
  }

  .panel {
    padding: 32px 24px;
  }
}
